// client/src/utils/diagnostics.js

export function getDiagnostics(dataRows) {
    const flaggedRows = [];
    dataRows.forEach(row => {
      let reasons = [];
      if (row.supply_voltage !== undefined && row.supply_voltage < 10.5) {
        reasons.push('Low supply voltage');
      }
      if (row.raw_co2_ppm !== undefined && row.raw_co2_ppm <= 0) {
        reasons.push('Raw CO₂ is zero/negative');
      }
      if (row.sensor_temperature_c !== undefined &&
        (row.sensor_temperature_c < 0 || row.sensor_temperature_c > 40)
      ) {
        reasons.push('Sensor temp out of range');
      }
      if (row.logger_temp_ad_counts !== undefined &&
        (row.logger_temp_ad_counts === 0 || row.logger_temp_ad_counts === 4095)
      ) {
        reasons.push('Logger Temp A/D at extreme (0 or 4095)');
      }
      if (reasons.length > 0) {
        flaggedRows.push({ ...row, reasons: reasons.join('; ') });
      }
    });
    return flaggedRows;
  }
  